module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_letter-to-DanielWolf_9Feb1960.844d12c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_letter-to-DanielWolf_9Feb1960.jpg
// module id = fkH+
// module chunks = 0